import { getCurrentDateUTC, getLocalAuthDetails } from '../utils/common.util'
import { getMessageUniqueId } from './../utils/common.util'
import {
	loadActivityStatusAndFormsList,
	loadSubmittedFormList,
} from './../services/form.service'

export const loadActivityStatusAndFormsListQuery = async params => {
	try {
		let payload = {
			...params,
			page_limit: 50,
			page_start: 0,
			...getLocalAuthDetails(),
		}

		let res = await loadActivityStatusAndFormsList(payload)
		if (res.data.status === 200) {
			return res.data.response
		}
	} catch (error) {
		console.error(error)
		return error
	}
}

export const loadSubmittedFormListQuery = async params => {
	try {
		const auth = getLocalAuthDetails()
		let payload = {
			...params,
			...auth,
			user_workforce_id: auth.workforce_id,
			user_account_id: auth.account_id,
			access_level_id: 0,
			track_latitude: 0,
			track_longitude: 0,
			track_gps_accuracy: 0,
			track_gps_status: 0,
			track_gps_location: 0,
			message_unique_id: getMessageUniqueId(),
			log_datetime: '1970-01-01 00:00:00',
			track_gps_datetime: getCurrentDateUTC(),
		}

		let res = await loadSubmittedFormList(payload)
		if (res.data.status === 200) {
			if (res.data.response.length > 0) {
				return res.data.response
			}
		}
		return []
	} catch (error) {
		console.error(error)
		return error
	}
}
